module.exports = __webpack_public_path__ + "static/img/yytx08.b7ed8f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx08.png
// module id = 788
// module chunks = 0